import { Label } from "@ui/label";
import { Select } from "@ui/select";
import { DatePicker, DateTimePicker, TimePicker } from "@ui/datetime-selector";
import { ValidationError } from "@/components/ui/validation-error";
import type { SelectOption } from "@ui/select/single-select";
import type { DateHeaderType } from "./types";
import { Input } from "@ui/input";
import { GridHeaderVisibilityFields } from "./visibility-fields";

const dateSubtypeOptions: SelectOption<string>[] = [
    { label: "Date", value: "date", key: "date" },
    { label: "Time", value: "time", key: "time" },
    // { label: "Date & Time", value: "datetime" },
];

export function DateHeaderFields({
    header,
    updateHeader,
    headerError,
}: DateHeaderType) {
    const dateSubtype =
        header.type === "date" ? ((header.subtype as string) ?? "date") : "date";

    return (
        <GridHeaderVisibilityFields header={header} updateHeader={updateHeader}>
            <div className="flex flex-col gap-2">
                <Label>Date Subtype</Label>
                <Select
                    mode="single"
                    options={dateSubtypeOptions}
                    value={dateSubtype}
                    onChange={(value) =>
                        updateHeader({
                            subtype: (value || "date") as "date" | "time" | "datetime",
                        })
                    }
                    placeholder="Select subtype"
                />
            </div>
            <div>
                <Label>Placeholder</Label>
                <Input
                    value={(header.placeholder as string) ?? ""}
                    placeholder="Placeholder"
                    onChange={(e) => updateHeader({ placeholder: e.target.value })}
                />
            </div>
            <div>
                <Label>Default Value</Label>
                {dateSubtype === "time" ? (
                    <TimePicker
                        name={`grid-header-${header.key}-default-time`}
                        value={
                            "defaultValue" in header &&
                                typeof header.defaultValue === "number"
                                ? header.defaultValue
                                : undefined
                        }
                        onChange={(timestamp) => updateHeader({ defaultValue: timestamp })}
                    />
                ) : dateSubtype === "datetime" ? (
                    <DateTimePicker
                        name={`grid-header-${header.key}-default-datetime`}
                        value={
                            "defaultValue" in header &&
                                typeof header.defaultValue === "number"
                                ? header.defaultValue
                                : undefined
                        }
                        onChange={(timestamp) => updateHeader({ defaultValue: timestamp })}
                    />
                ) : (
                    <DatePicker
                        name={`grid-header-${header.key}-default-date`}
                        value={
                            "defaultValue" in header &&
                                typeof header.defaultValue === "number"
                                ? header.defaultValue
                                : undefined
                        }
                        onChange={(timestamp) => updateHeader({ defaultValue: timestamp })}
                    />
                )}
            </div>
            {headerError && <ValidationError>{headerError}</ValidationError>}
        </GridHeaderVisibilityFields>
    );
}
